// extracted by mini-css-extract-plugin
module.exports = {"profileContainer":"BusinessProfile_profileContainer__2_jgX","profileSection":"BusinessProfile_profileSection__C6j4q"};